// extracted by mini-css-extract-plugin
module.exports = {"subHeader":"SubHeader_subHeader__2v0Vh","product":"SubHeader_product__1-CwM"};